// import external dependencies
import 'jquery';

// Import everything from autoload
import './autoload/_bootstrap.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import templateGeneralPage from './routes/templateGeneralPage';
import templateResources from './routes/templateResources';
import templateEvents from './routes/templateEvents';
import templateNews from './routes/templateNews';
import templateNewsItem from './routes/templateNewsItem';
import templateBookATour from './routes/templateBookATour';
import templateCheckout from './routes/templateCheckout';
import templateBookingManagerBookings from './routes/templateBookingManagerBookings';
import templateBookingManagerCreateABooking from './routes/templateBookingManagerCreateABooking';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // General page template
  templateGeneralPage,
  // Resources template
  templateResources,
  // Event listing template
  templateEvents,
  // News listing template
  templateNews,
  // News item template
  templateNewsItem,
  // Book a tour template
  templateBookATour,
  // Checkout template
  templateCheckout,
  // Booking manager bookings
  templateBookingManagerBookings,
  // Booking manager create a booking
  templateBookingManagerCreateABooking,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js